<template>
  <div class="mdc-drawer-scrim" />
</template>

<script>
import { baseComponentMixin, themeClassMixin } from "../base";

export default {
  mixins: [baseComponentMixin, themeClassMixin]
};
</script>

<style scoped></style>
